<script setup lang="ts">
  import { route } from '@procommerce/visitor';
  import type { PropType } from 'vue';
  import type { SaleOfferMessage, SaleOfferQuotation } from '$storefront';

  defineOptions({
    layout: ['StoreLayout', 'AccountLayout'],
    inheritAttrs: false,
  });

  defineProps({
    offer: { type: Object, required: true },
    messages: { type: Array as PropType<SaleOfferMessage[]>, required: true },
    quotations: { type: Array as PropType<SaleOfferQuotation[]>, required: true },
  });
</script>
<template>
  <AccountMobileNavigation :href="route('web.account.offers.index')">
    {{ $t('Zapytanie Nr #:nr', { nr: offer.id }) }}
  </AccountMobileNavigation>

  <OfferDetailsView :quotations="quotations" :messages="messages" :offer="offer" />
</template>
